import Dashboard from '../../lib/api/Dashboard';

export function unplannedRoutesRequest() {
	return {
		type: 'UNPLANNED_ROUTES_REQUEST'
	};
}

export function unplannedRoutesSuccess(data) {

	return {
		type: 'UNPLANNED_ROUTES_SUCCESS',
		data: data,
		lastUpdate: Date.now()
	};
}

export function unplannedRoutesError(error) {
	return {
		type: 'UNPLANNED_ROUTES_ERROR',
		error: error
	};
}


export function addUnplannedRoute(data) {

	return {
		type: 'UNPLANNED_ROUTE_ADD',
		data: data
	};
}

export function updateUnplannedRoute(data) {

	return {
		type: 'UNPLANNED_ROUTE_UPDATE',
		data: data
	};
}

/* Async actions */

export function getUnplannedRoutes(params) {

	return function(dispatch, getState) {

		const state = getState();

		if (state.unplannedRoutes.loading) {
			//return Promise.resolve();
		}
		
		dispatch(unplannedRoutesRequest());

		return Dashboard.getUnplannedRoutes(params).then(
			data =>  dispatch(unplannedRoutesSuccess(data)),
			error => dispatch(unplannedRoutesError(error))
		);
	}
}
